import values from '../../../res/values';
import color from '../../../res/color';

export default {
    main: {
        height: '100%',
        width: '100%',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-around',
        alignSelf: 'center',
        alignItems: 'center',
    },
    image:{
        height:'auto',
        width:'100%',
    },
    buttonBack: {
        width: '20%',
        alignSelf: 'center',
        alignItems: 'center',
        padding: '2%',
        userSelect: "none",
        cursor: 'pointer',
        border: '3px solid' + color.lightBorderColor,
    },
}